import { render, staticRenderFns } from "./StockLog.vue?vue&type=template&id=3da1ca4e&"
import script from "./StockLog.vue?vue&type=script&lang=js&"
export * from "./StockLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockLog.vue"
export default component.exports